import { FormControl, FormLabel, useBreakpointValue } from "@chakra-ui/react";
import { type RawPkh, isSaplingAddress } from "@umami/chains";

import { AddressTile } from "../../../AddressTile/AddressTile";

type FromAddressPreviewFieldProps = {
  address: RawPkh;
};

export const FromAddressPreviewField = ({ address }: FromAddressPreviewFieldProps) => {
  const hideBalance = useBreakpointValue({ base: true, md: false });
  const isSapling = isSaplingAddress(address);
  const addressType = isSapling ? "sapling" : "implicit";

  return (
    <FormControl>
      <FormLabel width="full">From</FormLabel>
      <AddressTile address={{ type: addressType, pkh: address }} hideBalance={hideBalance} />
    </FormControl>
  );
};
